import React from 'react';

const LazyPageLoader = ({ page, fallback = <>...</>, ...restProps }) => {
  const Component = React.lazy(page);
  return (
    <React.Suspense fallback={fallback}>
      <Component {...restProps} />
    </React.Suspense>
  );
};

export default LazyPageLoader;
